var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypeDoc = function SvgTypeDoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 42"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#type-doc_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#type-doc_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBFAFA",
    d: "M4 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    d: "M13.899 33.096q-.595 0-1.061-.304a2.07 2.07 0 0 1-.73-.872q-.261-.57-.261-1.365t.265-1.361q.268-.566.735-.867.467-.3 1.058-.3.457 0 .735.153.281.15.435.352.156.2.243.355h.057v-2.433h.956V33h-.933v-.764h-.08q-.087.157-.25.358a1.4 1.4 0 0 1-.44.352q-.282.15-.73.15m.21-.815q.413 0 .697-.217.288-.221.435-.61.15-.39.15-.909 0-.51-.147-.894a1.3 1.3 0 0 0-.431-.598 1.14 1.14 0 0 0-.703-.214q-.432 0-.72.224-.287.223-.434.61a2.5 2.5 0 0 0-.144.873q0 .492.147.885t.435.623q.29.227.716.227m5.653.818q-.69 0-1.204-.316a2.13 2.13 0 0 1-.8-.886q-.285-.568-.284-1.33 0-.763.285-1.335t.799-.889 1.204-.316 1.205.316.8.889.284 1.336q0 .76-.285 1.33-.285.569-.799.885t-1.204.316m.004-.802q.447 0 .741-.237.294-.236.435-.63.144-.392.144-.865 0-.47-.144-.863a1.4 1.4 0 0 0-.435-.636q-.294-.24-.741-.24-.45 0-.748.24-.294.24-.438.636-.14.393-.14.863 0 .473.14.866.144.393.438.63.297.236.748.236m5.42.802q-.714 0-1.228-.323a2.14 2.14 0 0 1-.786-.898 3 3 0 0 1-.275-1.31q0-.748.281-1.32.282-.576.793-.898.51-.323 1.205-.323.56 0 .997.208.438.204.706.575.272.37.323.866h-.93a1.1 1.1 0 0 0-.352-.594q-.271-.25-.728-.25-.4 0-.7.211a1.36 1.36 0 0 0-.464.595 2.3 2.3 0 0 0-.166.907q0 .537.163.927t.46.604q.3.215.707.215.27 0 .492-.1.224-.102.374-.29.154-.189.214-.454h.93q-.05.475-.31.85-.26.374-.694.588a2.25 2.25 0 0 1-1.013.214"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34d399",
    d: "M-4 0h48v4H-4z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#E8E8E8",
    d: "M12 .5h16A7.5 7.5 0 0 1 35.5 8v24a7.5 7.5 0 0 1-7.5 7.5H12A7.5 7.5 0 0 1 4.5 32V8A7.5 7.5 0 0 1 12 .5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "type-doc_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "type-doc_svg__a",
    width: 34,
    height: 42,
    x: 3,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_255_3557"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_255_3557",
    result: "shape"
  })))));
};
export default SvgTypeDoc;